<template>
    <div class="input-box">
        <el-radio-group v-model="maxType">
            <el-radio :label="0">无上限</el-radio>
            <el-radio :label="1"><el-input class="score-input" size="small" v-model="maxNum" placeholder="" /> 积分</el-radio>
        </el-radio-group>
    </div>
</template>

<script>
    export default {
        name: "ScoreDayMaxInput",
        model: {
            prop: "max",
            event: "maxChange"
        },
        props: {
            max: {
                type: Number,
                default: 0
            }
        },
        mounted: function () {

        },
        data: () => ({
            maxType: 0,
            maxNum: ""
        }),
        watch: {
            maxType: function (val) {
                if(val == 1) {
                    this.$emit("maxChange", this.maxNum ? this.maxNum : 1);
                }else{
                    this.$emit("maxChange", 0);
                }
            },
            max: function (val) {
                if(val > 0) {
                    this.maxType = 1;
                    this.maxNum = val;
                } else {
                    this.maxType = 0;
                    this.maxNum = "";
                }
            },
            maxNum: function (val) {
                let n = Number(val);
                if( n > 0) {
                    this.$emit("maxChange", n);
                }else{
                    this.$emit("maxChange", 0);
                }
            }
        }
    }
</script>

<style scoped>
    .score-input{
        width: 80px;
    }
</style>
